export default function Header() {
  const header = document.getElementById('header');

  // Shadow
  const handleHeaderShadow = () => {
    header.dataset.shadow = 'true';

    if (window.scrollY <= 0) {
      header.classList.remove('header--shadow');
    } else {
      header.classList.add('header--shadow');
    }
  };

  handleHeaderShadow();

  document.addEventListener('scroll', handleHeaderShadow);
}
